import React from 'react';
import styles from './index.module.scss'
import './iconCheck.scss'
import { ReactComponent as IconCheck } from './imgs/iconcheck.svg';

/**
 * Es un componente que toma un objeto con tres propiedades y devuelve un campo de entrada con una etiqueta y un mensaje de error.
 * @returns Un componente que representa un campo de entrada con una etiqueta y un mensaje de error si hay un error.
 */
class Input extends React.Component {

  render() {
    return (
      <div className={`${styles.cupra} ${!this.props.showErrorLabel ? styles.notLabel : ''}`}>
        <div className={styles.inputContainer}>
          <input type="text"
            className={`${styles.inputField} ${this.props.icon ? styles.inputIcon : ''} ${this.props.errors?.[this.props.name] ? styles.validation : ''} ${this.props.check ? styles.checkInput : ''}`}
            name={this.props.name}
            id={this.props.name}
            placeholder={' '}
            onChange={this.props.onChange}
          />
          <label htmlFor={this.props.name} className={styles.inputLabel + ` ${this.props.textHidden ? styles.textHidden : ''}`} >
            {this.props.inputLabel}{this.props.required && '*'}
          </label>
          {this.props.icon && (<><i className={styles.line}></i><button type='submit' className={styles.icon}></button></>)}
        </div>

        {/** consultar guia */}
        {
          (this.props.showErrorGuiaLabel && this.props.state.errorlabel) && (
            <div className={styles.errorMessage}>
              {this.props.errorGuiaText}
            </div>
          )
        }

        {/** recuperar correo */}
        {
          (this.props.showErrorMailLabel && this.props.state.errorlabelcorreo) && (
            <div className={styles.errorMessage}>
              {this.props.errorMailText}
            </div>
          )
        }

        {/** campo de asunto */}
        {
          (this.props.showErrorAsunto && this.props.state.errorlabel) && (
            <div className={styles.errorMessage}>
              {this.props.errorText}
            </div>
          )
        }

        {/** campo de mensaje*/}
        {
          (this.props.showErrorMensaje && this.props.state.errorMensajeLabel) && (
            <div className={styles.errorMessage}>
              {this.props.errorMensajeLabel}
            </div>
          )
        }

        <span className={this.props.check ? 'iconCheck-container d-flex justify-content-end' : 'd-none'}><IconCheck className='iconCheck' /></span>
      </div>
    )
  }
}

export default Input
